import _ from 'lodash'
import $ from 'jquery'
import license from 'scoreboard/components/license'
import i18n from 'scoreboard/components/i18n'
import config from 'scoreboard/components/config'

const smsKeys = {
	'active-viewers': 'admin.group.groupType.activeViewers',
	'updaters': 'admin.group.groupType.applicationUsers',
	'power-users': 'admin.group.groupType.performanceManagers',
	'admins': 'admin.group.groupType.administrators'
}

// issue #7302 ticket:13622 only 3 group types for most customers
const legacyKeys = _.omit(smsKeys, 'power-users')

const impactKeys = _.assign({
	'view-only': 'admin.group.groupType.viewOnly'
}, legacyKeys)

const ACTIVE_VIEWERS = 'active-viewers'
const UPDATERS = 'updaters'
const POWER_USERS = 'power-users'
const ADMINS = 'admins'
const VIEW_ONLY = 'view-only'

const GroupType = {

	ACTIVE_VIEWERS, UPDATERS, POWER_USERS, ADMINS, VIEW_ONLY,

	accessLevelOrder: [ADMINS, POWER_USERS, UPDATERS, ACTIVE_VIEWERS,
		VIEW_ONLY],

	/**
	 * Map of all the group type and theirs message keys taking into account the license model
	 */
	messageKeysByType: function(lic = license) {
		if (config.sms) {
			return smsKeys
		}
		return lic.licenseModel == 'impact' ? impactKeys : legacyKeys
	},

	/**
	 * Returns an array group type ids by their access level ordered from highest
	 * to lowest
	 */
	typesByAccessLevelOrder: function() {
		return _.filter(this.accessLevelOrder, this.messageKey.bind(this))
	},

	/**
	 * Returns the group type key based on the group type
	 */
	messageKey: function(type) {
		return this.messageKeysByType()[type]
	},

	/**
	 * Returns the default group type key taking into account the license model
	 */
	defaultMessageKey: function() {
		// #35305 default for sms is 'active-viewers'
		if (config.sms) {
			return 'active-viewers'
		}
		// #8042 default should be viewers, moved here to keep all magic strings in one place
		return license.licenseModel == 'impact' ? 'view-only' : 'active-viewers'
	},

	/**
	 * Returns the label for a given group type
	 */
	label: function(type) {
		let key = this.messageKey(type)
		return key ? i18n.get(key) : null
	},

	/**
	 * Takes an collection and assigns the a "groupTypeLabel" property to each
	 * object where the value is the label of the group type corresponding
	 * to the "groupType" property on each object in the collection
	 */
	groupTypeLabelAssignTo: function(principals) {
		_.each(principals, (principal) => {
			principal.groupTypeLabel = this.label(principal.groupType)
		})
		return principals
	},

	/**
	 * If the group type allows the user read (view) only access.
	 */
	isReadOnly(type) {
		return type === ACTIVE_VIEWERS || type === VIEW_ONLY
	},

	renderSelect ({ name, value }) {
		let html = `<select name="${name}">`

		// add options, ordered by access level
		let groupTypes = this.typesByAccessLevelOrder().forEach(id => {
			let label = _.escape(this.label(id))
			html += `<option value="${id}">${label}</option>`
		})

		return $(html + '</select>')
	}

}

export default GroupType

GroupType.__filename__ = 'admin/principals/groups/group-type.js'
